module.exports = __webpack_public_path__ + "img/icon-sence.600f8e55.svg";